<template>
  <div class="animated fadeIn">
    <b-row class>
      <b-col offset-md="1">
        <h2>สมัครสมาชิก</h2>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col md="4" offset-md="1">
        <b-row v-if="showRegForm" class="mt-2">
          <b-col sm="12">
            <TextInput
              :value="$v.email"
              id="email"
              feedback="ระบุอีเมล"
              label="อีเมล"
              placeholder="ตัวอย่าง: user@logisty.asia"
              :isRequired="true"
            />
          </b-col>
        </b-row>
        <b-row v-if="showRegForm" class="mt-2">
          <b-col sm="12">
            <TextInput
              :value="$v.password"
              id="password"
              feedback="จำเป็นต้องระบุ"
              label="ตั้งรหัสผ่านสำหรับบัญชีของคุณ"
              placeholder
              :isRequired="true"
              type="password"
            />
          </b-col>
        </b-row>
        <b-row v-if="showRegForm" class="mt-2">
          <b-col sm="12">
            <SelectInput
              :value="$v.type"
              id="type"
              feedback="เลือกประเภท"
              label="ประเภทบริษัท"
              :options="companyTypeOptions"
              :isRequired="true"
            />
          </b-col>
        </b-row>
        <b-row v-if="showRegForm" class="mt-2">
          <b-col sm="12">
            <TextInput
              :value="$v.companyName"
              id="companyName"
              feedback="จำเป็นต้องระบุ"
              label="ชื่อบริษัท"
              placeholder="ตัวอย่าง : เอบีซี ขนส่ง"
              :isRequired="true"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row v-if="showRegForm" class="mt-2">
          <b-col sm="12">
            <TextInput
              :value="$v.name"
              id="name"
              feedback="จำเป็นต้องระบุ"
              label="ชื่อ-นามสกุล"
              placeholder="ตัวอย่าง : นายสมชาย คนดี"
              :isRequired="true"
              type="text"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col sm="12">
            <label for="phoneNumber">
              เบอร์โทร (ไม่ต้องใส่ -)
              <span class="text-danger">*</span>
            </label>
            <b-input-group>
              <b-form-input
                v-model="phoneNumber"
                id="phoneNumber"
                :state="$v.phoneNumber.$dirty ? !$v.phoneNumber.$error : null"
                placeholder="ตัวอย่าง : 0812345678"
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" id="otp-button" @click="requestOTP">ส่งรหัส OTP</b-button>
              </b-input-group-append>
              <b-form-invalid-feedback
                id="phoneNumber-live-feedback"
              >ระบุเบอร์โทรศัพท์มือถือเท่านั้น</b-form-invalid-feedback>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row v-if="showRegForm" class="mt-2">
          <b-col sm="12">
            <TextInput
              :value="$v.otp"
              id="otp"
              feedback="ระบุ otp"
              label="รหัส OTP ที่ได้รับ"
              placeholder="ตัวอย่าง: 123456"
              :isRequired="true"
            />
          </b-col>
        </b-row>
        <b-row class="mt-4 mb-4 d-md-none">
          <b-col sm="12" class="mb-2">
            <b-button block variant="primary" @click="register">ยืนยันสมัคร</b-button>
          </b-col>
          <b-col sm="12">
            หรือเข้าสู่ระบบ
            <b-link :to="{name: 'เข้าสู่ระบบ'}">คลิกที่นี่</b-link>
          </b-col>
          <b-col sm="12">
            หรือลืมรหัสผ่าน
            <b-link :to="{name: 'ลืมรหัสผ่าน'}">คลิกที่นี่</b-link>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="4" offset-md="1">
        <b-row>
          <b-col>
            <b-media class="mt-2">
              <template v-slot:aside>
                <span class="fa-stack fa-3x logisty-numbered-icon">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <strong class="fa-stack-1x text-white">1</strong>
                </span>
              </template>
              <p class="mb-0 logisty-numbered-detail">กรอกข้อมูลให้ครบแล้วกดปุ่ม "ยืนยัน"</p>
            </b-media>
            <b-media class="mt-4">
              <template v-slot:aside>
                <span class="fa-stack fa-3x logisty-numbered-icon">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <strong class="fa-stack-1x text-white">2</strong>
                </span>
              </template>
              <p
                class="mb-0 logisty-numbered-detail"
              >เมื่อเข้าสู่ระบบแล้ว สร้างโปรไฟล์บริษัทโดยกดปุ่ม "สร้าง/แก้ไข โปรไฟล์ของคุณ" สีเหลือง มุมขวาบน จากนั้นกรอกรายละเอียดให้ครบถ้วน</p>
            </b-media>
            <b-media class="mt-4">
              <template v-slot:aside>
                <span class="fa-stack fa-3x logisty-numbered-icon">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <strong class="fa-stack-1x text-white">3</strong>
                </span>
              </template>
              <p
                class="mb-0 logisty-numbered-detail"
              >รอเจ้าหน้าที่ติดต่อกลับเพื่อยืนยันตัวตนภายในไม่เกิน 1-2 วันทำการ</p>
            </b-media>
            <b-media class="mt-4">
              <template v-slot:aside>
                <span class="fa-stack fa-3x logisty-numbered-icon">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <strong class="fa-stack-1x text-white">4</strong>
                </span>
              </template>
              <p
                class="mb-0 logisty-numbered-detail"
              >เมื่อบัญชีของท่านได้รับการอนุมัติ ท่านสามารถใช้งานแพลตฟอร์มได้อย่างเต็มรูปแบบ เสร็จสิ้นขั้นตอนการลงทะเบียน</p>
            </b-media>
            <b-media class="mt-4">
              <p
                class="mb-0 logisty-numbered-detail"
              >หมายเหตุ : หากสมัครในนามบริษัทเดียวกันหลายบัญชี ให้สร้างโปรไฟล์ (ข้อ 2) เพียงบัญชีแรกสุดที่สมัครเข้ามา</p>
            </b-media>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="d-sm-down-none">
      <b-col md="4" offset-md="1">
        <b-row class="mt-3">
          <b-col sm="12">
            <b-button variant="primary" @click="register">ยืนยันสมัคร</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col sm="12">
            หรือเข้าสู่ระบบ
            <b-link :to="{name: 'เข้าสู่ระบบ'}">คลิกที่นี่</b-link>
          </b-col>
          <b-col sm="12">
            หรือลืมรหัสผ่าน
            <b-link :to="{name: 'ลืมรหัสผ่าน'}">คลิกที่นี่</b-link>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <ModalLoading />
  </div>
</template>

<script>
import firebase from 'firebase'
import ModalLoading from '../components/ModalLoading'
import TextInput from '../components/TextInput'
import User from '../services/http/User'
import Company from '../services/http/Company'
import SelectInput from '../components/SelectInput'

import { validationMixin } from 'vuelidate'
import { required, email, helpers } from 'vuelidate/lib/validators'
const thPhoneNumber = helpers.regex('thPhoneNumber', /^0[0-9]{9}$/)

export default {
  components: {
    ModalLoading,
    TextInput,
    SelectInput
  },
  mixins: [validationMixin],
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    },
    companyName: {
      required
    },
    name: {
      required
    },
    otp: {
      required
    },
    phoneNumber: {
      required,
      thPhoneNumber
    },
    type: {
      required
    }
  },
  data () {
    return {
      phoneNumber: null,
      otp: null,
      email: null,
      password: null,
      companyName: null,
      name: null,
      showRegForm: true,
      type: null,
      companyTypeOptions: [
        { value: 'company-limited', text: 'บริษัทจำกัด' },
        { value: 'public-company-limited', text: 'บริษัท มหาชน จำกัด' },
        { value: 'limited-partnership', text: 'ห้างหุ้นส่วนจำกัด' }
      ],
      otpRequested: false
    }
  },
  async mounted () {
    firebase.auth().languageCode = 'th'

    // Start Firebase invisible reCAPTCHA verifier
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('otp-button', {
      'size': 'invisible',
      'callback': function (response) {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // console.log('invisable')
        console.log('allow')
      }
    })

    window.recaptchaVerifier.render().then((widgetId) => {
      window.recaptchaWidgetId = widgetId
    })
  },
  methods: {
    async requestOTP () {
      this.$v.phoneNumber.$touch()
      if (this.$v.phoneNumber.$anyError) {
        grecaptcha.reset(window.recaptchaWidgetId)
        return
      }
      var phoneNumberPrefix = '+66'
      var phoneNumber = phoneNumberPrefix + this.phoneNumber.slice(1)
      var appVerifier = window.recaptchaVerifier

      Window.Event.$emit('showModalLoading')
      console.log(Window.Event)
      var result = await firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
        .then(function (confirmationResult) {
          // SMS sent. Prompt user to type the code from the message, then sign the
          // user in with confirmationResult.confirm(code).
          window.confirmationResult = confirmationResult
          return true
        }).catch(function (error) {
          // Error; SMS not sent
          // ...

          console.log('signin' + error)
          return false
        })

      Window.Event.$emit('closeModalLoading')

      if (result) {
        console.log('requested otp')
        this.otpRequested = true
        window.dataLayer.push({
          event: 'otp-requested',
          phoneNumber: phoneNumber
        })
        // this.showRegForm = true
      } else {
        window.dataLayer.push({
          event: 'otp-error',
          phoneNumber: phoneNumber
        })
        await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
        grecaptcha.reset(window.recaptchaWidgetId)
      }
    },
    async register () {
      if (!this.otpRequested) {
        await this.$bvModal.msgBoxOk('ท่านยังไม่ได้ส่งรหัส OTP', this.$getConst('okModalClass'))
        return
      }
      this.$v.$touch()

      if (this.$v.$anyError) {
        return
      }

      Window.Event.$emit('showModalLoading')

      var result = await confirmationResult.confirm(this.otp).then(function (result) {
        // User signed in successfully.
        var user = result.user
        // console.log(user)
        return true
      }).catch(function (error) {
        // User couldn't sign in (bad verification code?)
        // ...
        console.log(error)
        return false
      })

      if (result) {
        var user = new User()
        var data = {
          phoneNumber: this.phoneNumber,
          password: this.password,
          email: this.email,
          companyName: this.companyName,
          name: this.name,
          type: this.type
        }

        try {
          var reg = await user.emailRegister(data)
          if (reg.code === 1) {
            window.dataLayer.push({
              event: 'registered',
              companyName: this.companyName
            })
            await this.$bvModal.msgBoxOk('ลงทะเบียนสำเร็จ', this.$getConst('okModalClass'))
            this.$cookies.set('email', this.email)
            this.$cookies.set('token', reg.token)
            this.$cookies.set('companyId', reg.company._id)
            window.analytics.identify({ email: this.email })
            window.analytics.track('register', { email: this.email })
            Window.Event.$emit('checkLogin')
            await this.$store.dispatch('checkCompanyStatus')
            var company = new Company()
            var companyInfo = await company.getCompanyInfo()
            if (companyInfo.profileUrl) {
              this.$router.push({ name: 'โปรไฟล์', params: { companyUrl: companyInfo.profileUrl } })
            } else {
              this.$router.push({ name: 'แก้ไขข้อมูลบริษัท' })
            }
          } else if (reg.code === 110) {
            await this.$bvModal.msgBoxOk('มีอีเมลนี้ในระบบแล้ว ถ้าท่านจำรหัสผ่านไม่ได้ กรุณาคลิก ลืมรหัสผ่าน เพื่อตั้งรหัสผ่านใหม่', this.$getConst('okModalClass'))
            this.otp = null
          } else {
            await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
          }
        } catch (error) {
          console.log(error)
          await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
          grecaptcha.reset(window.recaptchaWidgetId)
        }
      } else {
        await this.$bvModal.msgBoxOk('รหัส OTP ไม่ถูกต้อง', this.$getConst('okModalClass'))
      }

      Window.Event.$emit('closeModalLoading')
    }
  }
}
</script>
